<template>
  <div class="gp-content">
    <div class="content-wrapper" :class="{ 'scroll-vertical': scroll }">
      <div class="left">
        <slot></slot>
      </div>
      <div v-if="showRight" class="right">
        <slot name="right"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SplitPanelPage',
  props: {
    scroll: {
      type: Boolean,
      default: true,
    },
    showRight: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>

.content-wrapper {
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  height: 100%;
}

.left {
  flex-grow: 1;
}

.right {
  flex-basis: $info-panel-width;
  border-left: 1px solid $border-color;
}
</style>
